import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import PendingIcon from "@mui/icons-material/Pending";
import RemoveCircleIcon from "@mui/icons-material/RemoveCircle";
import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import { useQuery } from "@tanstack/react-query";
import { useContext, useEffect, useState } from "react";
import { FactoryFloorContext } from "../../../contexts/FactoryFloorContext";
import { genericGet } from "../../../services/api.service";
import { CardStyle } from "../../../styles/card";
import { IObra, ObraState, TipoOperacao } from "../../Obras/newObra/IObra";
import { InstrucoesTrabalho } from "./InstrucoesDeTrabalho";

const InfoDisplay = ({ info }: { info: { value: string | undefined; label: string }[] }) => {
	return (
		<>
			{info.map((i) => (
				<p>
					<span style={{ fontWeight: "bold" }}>{i.label}:</span> {i.value ? i.value : "-"}
				</p>
			))}
		</>
	);
};

const OperacoesStateMap = {
	[TipoOperacao.PROJETO]: "estadoProjeto",
	[TipoOperacao.CONTROLO_QUALIDADE]: "estadoControloEQualidade",
	[TipoOperacao.CNC]: "estadoCnc",
	[TipoOperacao.EXPEDICAO]: "estadoExpedicao",
	[TipoOperacao.ACABAMENTO]: "estadoAcabamentos",
	[TipoOperacao.CONVENCIONAIS]: "estadoConvencionais",
	[TipoOperacao.SERROTE]: "estadoSerrote",
	[TipoOperacao.TRATAMENTO]: "estadoTratamentos",
	[TipoOperacao.SUBCONTRATACAO]: "",
};

enum OperacaoState {
	POR_INICIAR = "Por iniciar",
	EM_ANDAMENTO = "Em andamento",
	EM_PAUSA = "Em pausa",
	CONCLUIDO = "Concluído",
	INEXISTENTE = "Inexistente",
}

export function SeleccaoObraEntregaOperacao({ scannerConnected }: any) {
	const { selectionValues, setSelectionValues } = useContext(FactoryFloorContext);

	const [entregas, setEntregas] = useState<any[]>([]);
	const [operacoes, setOperacoes] = useState<{ name: string; state: OperacaoState }[]>([]);

	const { data: obras } = useQuery({
		queryKey: ["obras"],
		queryFn: async () => (await genericGet("/obras?page=1&take=100000&projection=min")).data,
		onSuccess: (d) => {
			console.log("Obras: ", d);
		},
	});

	useEffect(() => {
		if (selectionValues.obra) {
			genericGet(`/obras/${selectionValues.obra?.id}/entregas`).then((d) => {
				setEntregas(d.data);
			});
		}
	}, [selectionValues.obra]);

	useEffect(() => {
		if (selectionValues.obra) {
			genericGet(`/obras/${selectionValues.obra?.id}/entregas/operacoes/${selectionValues.entrega?.id}`).then((d) => {
				setOperacoes(d);
			});
		}
	}, [selectionValues.entrega]);

	const getIconByState = (state: OperacaoState) => {
		if (state === OperacaoState.POR_INICIAR) {
			return <RemoveCircleIcon className="text-cyan-500" />;
		} else if (state === OperacaoState.EM_ANDAMENTO) {
			return <PendingIcon className="text-yellow-400" />;
		} else if (state === OperacaoState.CONCLUIDO) {
			return <CheckCircleIcon className="text-lime-500" />;
		}
	};
	const getObraBackgroundColor = (obra: IObra) => {
		console.log("Estado: ", obra.state);
		if (obra?.state === ObraState.DELIVERED) return "rgba(52, 235, 110, 0.6)";
		else if (obra?.state === ObraState.ONGOING) return "rgba(235, 220, 52, 0.6)";
		else if (obra?.state === ObraState.TO_START) return "rgba(52, 168, 235, 0.6)";
		else if (obra?.state === ObraState.CANCELLED) return "rgba(235, 79, 52, 0.6)";
	};

	if (scannerConnected) return null;

	return (
		<div style={{ display: "flex", marginLeft: 0, margin: 30, marginTop: 0, paddingTop: 20, ...CardStyle, padding: 15, paddingBottom: 20 }}>
			<div style={{ width: "100%" }}>
				<h3 style={{ paddingLeft: 50 }}>Obra</h3>
				<div className="pl-12 py-2">
					<FormControl className="w-2/3">
						<InputLabel>Obra</InputLabel>
						<Select
							value={selectionValues?.obra ? selectionValues?.obra : null}
							renderValue={(o) => `${o?.number} - ${o?.client?.name}`}
							onChange={(_, newValue: any) => {
								setSelectionValues({ obra: newValue.props.value });
							}}
							label={"Obra"}
							placeholder={"Seleccione Obra"}
							labelId={"input-id"}
						>
							{obras?.length
								? obras.map((o: IObra, idx: number) => {
										return (
											<MenuItem sx={{ backgroundColor: getObraBackgroundColor(o) }} key={idx} value={o as any}>
												<div className="flex flex-row w-full justify-between items-center">
													<div>{`${o?.number} - ${o?.client?.name}`}</div>
													<div>{o.state}</div>
												</div>
											</MenuItem>
										);
								  })
								: null}
						</Select>
					</FormControl>
				</div>
				<div style={{ paddingLeft: 50 }}>
					<InfoDisplay
						info={[
							{ label: "Número", value: selectionValues.obra?.number },
							{ label: "Cliente", value: selectionValues.obra?.client?.name },
							{ label: "Estado", value: selectionValues.obra?.state },
							{ label: "Nota de encomenda", value: selectionValues.obra?.orderNote },
						]}
					/>
				</div>
			</div>
			<div style={{ width: "100%" }}>
				<h3 style={{ paddingLeft: 50 }}>Entrega</h3>
				<div className="pl-12 py-2">
					<FormControl className="w-2/3">
						<InputLabel>Entrega</InputLabel>

						<Select
							disabled={!entregas?.length}
							value={selectionValues?.entrega}
							renderValue={(v) => v?.publicDeliveryDate?.toString().split("T")[0]}
							onChange={(_, newValue: any) => {
								console.log("Entrega: ", newValue.props.value);
								setSelectionValues({ entrega: newValue.props.value });
							}}
							label={"Entrega"}
							labelId={"input-id"}
						>
							{entregas?.length
								? entregas.map((l, idx) => {
										return (
											<MenuItem key={idx} value={l}>
												{l.publicDeliveryDate.toString().split("T")[0]}
											</MenuItem>
										);
								  })
								: null}
						</Select>
					</FormControl>
				</div>
				<div style={{ paddingLeft: 50 }}>
					<InfoDisplay
						info={[
							{ label: "Duração total prevista (h)", value: selectionValues.entrega?.duration?.toString() },
							{ label: "Percentagem total da obra", value: selectionValues.entrega?.percentage?.toString() },
							{ label: "Data prevista de início", value: selectionValues.entrega?.startingDate },
							{ label: "Data de entrega", value: selectionValues.entrega?.publicDeliveryDate?.toString().split("T")[0] },
						]}
					/>
				</div>
			</div>
			<div style={{ width: "100%" }}>
				<h3 style={{ paddingLeft: 50 }}>Operação</h3>
				<div className="pl-12 py-2">
					<FormControl className="w-2/3">
						<InputLabel>Operação</InputLabel>
						<Select
							value={selectionValues?.operacao}
							renderValue={(v) => v}
							onChange={(_, newValue: any) => {
								setSelectionValues({ operacao: newValue.props.value });
							}}
							label={"Operação"}
							labelId={"input-id"}
						>
							{operacoes.map((v, idx) => {
								return (
									<MenuItem key={idx} value={v.name}>
										<div className="flex w-full justify-between">
											{v.name} {getIconByState(v.state)}
										</div>
									</MenuItem>
								);
							})}
						</Select>
					</FormControl>
					<div>{selectionValues.operacao ? <InstrucoesTrabalho selectedOperacao={selectionValues.operacao} /> : null}</div>
				</div>
			</div>
		</div>
	);
}
